import ChartInteractionLegend from './chart-interaction-legend.component';
export default ChartInteractionLegend;
